<template>
  <div class="home home_pc">
    <Tophead :app-name="myApp.name" :app-logo="myApp.logo" />
    <div class="bread-cast-row">Latest GB & PLUS BLOG > GBWhatsApp</div>

    <section id="section-1" class="section-content no-padding">
      <div class="head-row">
        <div class="app-intro">
          <h1 class="section-1-rule" v-html="$global.formatstr(doc.s1.h1, month)"></h1>

          <div class="write-by">{{ $global.formatTimestamp(new Date()) }} By Hankson</div>

          <p class="writter-content">GB WhatsApp is the ultimate solution for those who want to take
            their chatting experience to the next level. This third-party WhatsApp mod is renowned
            for its exceptional features and customization options, which have made it a popular
            choice among millions of users worldwide. With GB WhatsApp, you can enjoy enhanced
            privacy, greater control over your chats, and a plethora of fun and exciting features to
            spice up your conversations. Whether you're looking for a way to customize your chat
            experience or simply want to add some flair to your interactions, GB WhatsApp has got
            you covered. So, let's dive in and explore all the amazing features that make GB
            WhatsApp the go-to chat program for anyone looking to elevate their messaging game!</p>

          <!-- <img src="@/assets/gb/New_banner@2x.png" alt="" class="writer-banner"> -->

          <lazysource :source="require('@/assets/gb/New_banner@2x.webp')"
            :img="require('@/assets/gb/New_banner@2x.png')" classname="writer-banner"></lazysource>
        </div>
      </div>

      <ApkDetail :doc="doc" />

      <DownloadBtn class="top-download fix has-exp" :exp-data="`show_${pageName}home_download`"
        :name="pageName" :from="from" :filename="filename" :isOffical="isOffical" />

      <h2 class="intro-title intro-title-1">
        <span @click="gotochat()" class="cursor-point">GBWhatsApp</span>
        vs WhatsApp – What’s The Difference?
      </h2>

      <p class="intro-item intro-item-2" v-html="doc.s1.intro_2_redirect"></p>

      <table id="playlist" cellspacing="0">
        <tbody>
          <tr>
            <th style="width: 29%">Feature</th>
            <th>GBWhatsApp</th>
            <th>WhatsApp</th>
          </tr>
          <tr v-for="(data, i) in feature" :key="i">
            <td>
              <div v-html="data.feature"></div>
            </td>
            <td>
              <div v-html="data.gb"></div>
            </td>
            <td>
              <div v-html="data.whs"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <S2 :doc="doc" />

    <h2 class="intro-title intro-title-3">Conclusion</h2>

    <p class="intro-item intro-item-4">GB Whatsapp is an excellent app that offers many exciting and
      additional features that the original Whatsapp lacks. Although it is not the official version,
      it is far better than the original as it provides users with unlimited unlocked features and a
      better experience. This APK app cannot be installed from the Play Store, so you can download
      it from the link provided above. <br><br>

      If you're worried about security, don't be. GBWhatsApp APK offers the same level of security
      and privacy as the official WhatsApp app. And if you're looking for even more features, you
      can also try WhatsApp Plus APK.<br><br>

      So why not share this amazing app with your friends? They'll love the latest features and
      customizable themes, and you won't have to worry about security since it has the same license
      as the official app. Give GBWhatsApp APK a try and see for yourself why it's one of the best
      messaging apps out there.</p>

    <S3 :doc="doc" :pageName="pageName" />

    <div id="snippet-box">
      <div class="snippet-title">Summary</div>

      <div itemscope="" itemtype="https://schema.org/SoftwareApplication">
        <div class="aio-info">
          <div class="snippet-label-img snippet-clear">Author Rating</div>
          <div class="snippet-data-img"><span class="star-img"><img src="@/assets/1star.png"
                alt="1star"><img src="@/assets/1star.png" alt="1star"><img src="@/assets/1star.png"
                alt="1star"><img src="@/assets/1star.png" alt="1star"><img src="@/assets/1star.png"
                alt="1star"></span></div>
          <div class="snippet-clear"></div>
          <div class="aggregate_sec" itemprop="aggregateRating" itemscope=""
            itemtype="https://schema.org/AggregateRating">
            <div class="snippet-label-img">Aggregate Rating</div>
            <div class="snippet-data-img"><span itemprop="ratingValue">3.75</span> based on <span
                class="rating-count" itemprop="ratingCount">48165</span> votes </div>
          </div>
          <div class="snippet-clear"></div>
          <div class="snippet-label-img">Software Name</div>
          <div class="snippet-data-img"> <span itemprop="name">GBWhatsApp APK</span></div>
          <div class="snippet-clear"></div>
          <div class="snippet-label-img">Operating System</div>
          <div class="snippet-data-img"> <span itemprop="operatingSystem">Android</span></div>
          <div class="snippet-clear"></div>
          <div class="snippet-label-img">Software Category</div>
          <div class="snippet-data-img"> <span itemprop="applicationCategory">App</span></div>
          <div class="snippet-clear"></div>
          <div class="snippet-label-img">Price</div>
          <div class="snippet-data-img"> <span itemprop="offers" itemscope=""
              itemtype="https://schema.org/Offer">
              <span itemprop="priceCurrency">$</span> <span itemprop="price"> 0</span></span></div>
          <div class="snippet-clear"></div>
          <div class="snippet-label-img">Landing Page</div>
          <div class="snippet-data-img"> <a itemprop="featureList"
              href="https://www.gbwhatsapp.download/">https://www.gbwhatsapp.download/</a></div>
          <div class="snippet-clear"></div>
        </div>
      </div>
    </div>

    <div class="download-rating-coantiner">
      <div class="rating-title"><img src="@/assets/like.png" alt="" /> Please rate us</div>

      <div class="rating-control-row star-rating-control">
        <div class="star-item" :class="{ active: i <= ratingStar }" @click="rate(i)" v-for="i in 5"
          :key="i"></div>
      </div>
    </div>

    <div class="collect-me-container" v-if="showCollect" @click="showCollect = false">
      <div class="collect-me-row">
        <img src="@/assets/close-icon.png" class="collect-close" @click="showCollect = false"
          alt="" />
        <h4>Thank you for your feedback</h4>
        <img class="collect-pic" src="@/assets/gb/collect.png" alt="" />
        <p>It is highly recommended to bookmark our website or join our official channel to timely
          obtain the latest version updates to avoid product expiration</p>
      </div>
    </div>

    <Footr :app-name="myApp.name" :app-logo="myApp.footLogo" :cooper="cooper" />

    <footer class="entry-footer">
      <p class="entry-meta">
        <span class="entry-categories">Filed Under: <a href="https://www.gbwhatsapp.download/"
            rel="category tag">GBWhatsApp APK</a></span>
        <span class="entry-tags">Tagged With:
          <a href="https://www.gbwhatsapp.download/gbwhatsapp.html" rel="tag">GBWhatsApp</a>,
          <a href="https://www.gbwhatsapp.download/gbwhatsapp-apk/" rel="tag">GB WhatsApp apk
            download</a>,
          <a href="https://www.gbwhatsapp.download/obwhatsapp-apk/" rel="tag">GB WhatsApp</a>,
          <a href="https://www.gbwhatsapp.download/temporarily-banned/" rel="tag">WhatsApp gb</a>,
          <a href="https://www.gbwhatsapp.download/yowhatsapp-apk/" rel="tag">GBWhatsApp update</a>,
          <a href="https://www.gbwhatsapp.download/whatsapp-plus-apk/" rel="tag">GBWhatsApp pro</a>
        </span>
      </p>
    </footer>

    <copy />

    <div class="telegram-row">
      <div class="telegram-item" @click="gotoTele()">
        <span class="telegram-num"></span>
      </div>
      <div class="telegram-msg" v-show="showTeleMsg">Join Our Telegram Channel</div>
    </div>

    <div id="saving-data" v-show="false"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import "@/css/gb/pc.scss";
import Tophead from "@/components/pc/Tophead.vue";
import Footr from "@/components/pc/Footr_gb.vue";
import DownloadBtn from "@/components/pc/DownloadBtnNew.vue";
import copy from "@/components/pc/copyright.vue";
import S2 from "./section2.vue";
import S3 from "./section3.vue";
import ApkDetail from "./apkdetail.vue";
import lazysource from "@/components/lazysource.vue";

export default {
  name: "pc",
  components: {
    Tophead,
    Footr,
    DownloadBtn,
    copy,
    S2,
    S3,
    ApkDetail,
    lazysource
  },
  data () {
    return {
      pageName: "gb",
      doc: null,
      myApp: null,
      from: null,
      filename: null,
      isOffical: 0,
      cooper: [
        {
          name: "ActualPost",
          link: "https://actualpost.com/gb-whatsapp-download/",
        },
        {
          name: "mpatel.org",
          link: "https://mpatel.org/gbwhatsapp-download/",
        },
        {
          name: "https://softmany.com/",
          link: "https://softmany.com/",
        },
        { name: "APKPosts.com", link: "https://apkposts.com/" },
      ],
      feature: [
        {
          feature: "Hide Online Status",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Airplane Mode",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Status Download",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Add Custom Fonts/Stickers",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Media Sharing",
          gb: "Maximum 200MB",
          whs: "Maximum 15MB",
        },
        {
          feature: "Status Character Length",
          gb: "Maximum 255",
          whs: "Maximum 139",
        },
        {
          feature: "Themes Supported",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "DND Mode",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Freeze Last Seen",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Disable Forwarded Tag",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Disable/Customize Calling",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Anti-Delete Status/Messages",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Security Lock",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Fully Customize",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Auto Reply",
          gb: '<div class="check-1"></div>',
          whs: '<div class="check-0"></div>',
        },
        {
          feature: "Increase Forward Limit",
          gb: "Maximum 250",
          whs: "Maximum 10",
        },
        {
          feature: "Increase Image Share Limit",
          gb: "Maximum 100",
          whs: "Maximum 30",
        },
      ],
      moreItem: [
        {
          name: "vml",
          icon: require("@/assets/gb/vml.png"),
          advertise: "Status Downloader",
          apk: "https://cdn.mypush.live/app/android/apk/Status-Downloader.apk",
        },
        {
          name: "play",
          icon: require("@/assets/gb/play.png"),
          advertise: "WhatsApp Player",
          apk: "https://cdn.mypush.live/app/android/apk/WhatsApp-Player.apk",
        },
        {
          name: "clean",
          icon: require("@/assets/gb/clean.png"),
          advertise: "WhatsApp Cleaner",
          apk: "https://cdn.mypush.live/app/android/apk/WhatsApp-Cleaner-2.2.04.apk",
        },
        {
          name: "wall",
          icon: require("@/assets/gb/wall.png"),
          advertise: "WhatsApp Wallpaper",
          apk: "https://cdn.mypush.live/app/android/apk/WhatsApp-Wallpaper.apk",
        },
      ],

      viewHeight: null,
      scrollEventFun: null,
      month: "",

      showTeleMsg: true,

      ratingStar: null,
      showCollect: false,
    };
  },
  created () {
    [this.from, this.filename, this.isOffical] = [
      this.$global.GetQueryString("from") || "",
      this.$global.GetQueryString("filename") || "",
      parseInt(this.$global.GetQueryString("isOffical")) || 0,
    ];
    console.log(`from:${this.from},filename:${this.filename}`);

    const ssrdata = this.$root.ssrData;
    if (ssrdata) {
      console.log("already render ssr data");
      const renderValue = JSON.parse(ssrdata);
      this.$store.commit("gb/UPDATE_APK", renderValue.apk);
      this.$store.commit("gb/UPDATE_RATE", renderValue.score);
      this.$store.commit("gb/UPDATE_CLICKS", renderValue.totalCount);
      this.$store.commit("gb/UPDATE_UPDATETIME", renderValue.updateTime);
    } else {
      console.log("fail");
      this.getOfficalApk();
    }

    this.myApp = this.$store.state.gb;
    this.doc = this.myApp.doc;

    console.log(this.myApp);
    this.$store.state.activeName = this.myApp.name;
    this.$store.state.activeLogo = this.myApp.logo;

    const monthArray = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    this.month = monthArray[new Date().getMonth()];

    this.$logEvent(`show_gbhome_pc`);

    console.log(this.$route);
  },
  metaInfo () {
    return {
      title: `GBWhatsApp APK Download  (Anti-Ban) ${this.$root.month} 2023 (Virus Free) | OFFICIAL`,
      script: [
        {
          vmid: "extscript",
          innerHTML: `
					{
						"@context": "https://schema.org",
						"@graph": [
							{
								"@type": "BreadcrumbList",
								"itemListElement": [
									{ "@type": "ListItem", "position": 1, "name": "GBWhatsApp", "item": "https://www.gbwhatsapp.download/" },
									{ "@type": "ListItem", "position": 2, "name": "GB WhatsApp apk download" , "item": "https://www.gbwhatsapp.download/gbwhatsapp-apk/" },
									{ "@type": "ListItem", "position": 3, "name": "GBWhatsApp Download 2023"  }
								]
							}
							
						]
					}
				`,
          type: "application/ld+json",
        },
      ],
      __dangerouslyDisableSanitizers: ["script"],
      meta: [
        {
          name: "keywords",
          vmid: "keywords",
          content:
            "gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download",
        },

        {
          name: "description",
          vmid: "description",
          content: `Download GBWhatsApp APK 2023 latest version. It's the BEST way to support OFFICIAL WhatsApp with extra features. Gb WhatsApp is 100% free & Anti-Ban.`,
        },
        {
          name: "og:description",
          vmid: "og:description",
          content: `Download GBWhatsApp APK 2023 latest version. It's the BEST way to support OFFICIAL WhatsApp with extra features. Gb WhatsApp is 100% free & Anti-Ban.`,
        },
        {
          name: "og:title",
          vmid: "og:title",
          content: `GBWhatsApp APK Download  (Anti-Ban) ${this.$root.month} 2023 (Virus Free) | OFFICIAL`,
        },
        {
          name: "image",
          vmid: "image",
          content: `https://cdn.mypush.live/img/icon_GB_new@2x.3474f003.png`,
        },
        {
          name: "og:url",
          vmid: "og:url",
          content: window.location.href,
        },
        {
          name: "og:image",
          vmid: "og:image",
          content: `https://cdn.mypush.live/img/icon_GB_new@2x.3474f003.png`,
        },
      ],
      // link: [
      // 	{
      // 		rel: "canonical",
      // 		vmid: "canonical",
      // 		href: `https://www.gbwhatsapp.download`,
      // 	},
      // ],
    };
  },
  mounted () {
    setTimeout(() => {
      this.viewHeight = window.innerHeight;
      this.scrollEvent();
      // 监听scroll事件
      this.scrollEventFun = this.$global.throttle(this.scrollEvent, 300);
      window.addEventListener("scroll", this.scrollEventFun, false);

      if (this.$route.params.scrollTo) {
        document
          .querySelector(`#${this.$route.params.scrollTo}`)
          .scrollIntoView({
            behavior: "smooth",
          });
      }
      this.$global.img_loading();
    }, 1000);

    setTimeout(() => {
      this.showTeleMsg = false;
    }, 2000);
  },
  beforeDestroy () {
    // 防止内存溢出
    window.removeEventListener("scroll", this.scrollEventFun, false);
  },
  methods: {
    rate (i) {
      if (this.$store.state.voteScore) {
        return;
      }
      console.log(i);
      this.ratingStar = i;
      this.rateScore(i);
    },
    rateScore (score) {
      this.$server.erate({ rate: score }).then((res) => {
        console.log(res);
        this.$store.commit("UPDATE_VOTING", score);
        console.log(this.$store.state.gb);
        this.showCollect = true;
        setTimeout(() => {
          this.showCollect = false;
        }, 8000);
      });
    },
    getAPK () {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$root.partners = res.data.partners;
            this.$store.commit("gb/UPDATE_APK", res.data.apk);
            this.$store.state.activeAPK = res.data.apk;
          } else {
            this.$store.state.activeAPK =
              process.env.VUE_APP_GBLINK;
            this.$store.commit(
              "gb/UPDATE_APK",
              process.env.VUE_APP_GBLINK
            );
          }
        });
    },
    getOfficalApk (set = 1) {
      this.$server
        .getOfficalApk({ domain: "gbwhatsapp.download", appName: "GB" })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            console.log("apk getted");
            console.log(this.myApp.apk);
            console.log(res.data.promotion.apk);
            document.getElementById("saving-data").innerHTML =
              JSON.stringify(res.data.promotion);
          }
        });
    },
    getOffsetTop (element) {
      let actualTop = element.offsetTop;
      let current = element.offsetParent;
      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }
      return actualTop;
    },
    // 获取窗口滚动高度
    scrollTop () {
      return (
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      );
    },
    scrollEvent () {
      let $scrollTop = this.scrollTop();
      let nodeArr = document.querySelectorAll(".has-exp");
      console.log($scrollTop);
      if ($scrollTop >= 20) {
        this.showTeleMsg = false;
      }
      for (let i = 0; i < nodeArr.length; i++) {
        let domTop =
          this.getOffsetTop(nodeArr[i]) +
          nodeArr[i].getBoundingClientRect().height / 3;
        // 当正文部分露出即发此曝光
        let topHeight = this.getOffsetTop(nodeArr[i]) - $scrollTop;
        // console.log('topHeight', topHeight);
        let bottomHeight = domTop - $scrollTop;
        if (topHeight >= 0 && bottomHeight <= this.viewHeight) {
          if (!nodeArr[i].getAttribute("data-exposure")) {
            nodeArr[i].setAttribute("data-exposure", "1");
            const _this = this;
            new Promise((resolve) => {
              resolve();
            }).then(() => {
              let expData = nodeArr[i].getAttribute("exp-data");
              _this.expPost(expData);
            });
          }
        }
        if (topHeight > this.viewHeight) return false;
      }
    },
    expPost (exposeData) {
      this.$logEvent(exposeData);
      console.log(`曝光统计log ${exposeData}`);
    },
    download () {
      // this.$global.download(this.myApp.apk);
      this.$logEvent("click_gwhome_download");
      this.$router.push({
        name: "gb_download_pc",
        params: { apk: this.myApp.apk },
      });
    },
    downloadad (name, apk) {
      this.$global.download(apk);
      this.$logEvent(`click_gwhome_${name}_download`);
    },
    gotoTele () {
      window.location.href = "https://t.me/gb_download";
    },
    gotochat () {
      window.location.href = "https://www.whatsplus.online/";
    },
  },
};
</script>
